var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tva-accordion']},_vm._l((_vm.content),function(item,itemIndex){return _c('div',{key:itemIndex,class:['tva-accordion-item', { open: _vm.open }],on:{"click":function($event){return _vm.toggleAccordion(itemIndex)}}},[_c('div',{class:[
        'tva-accordion-item-title',
        { closed: _vm.isSectionClosed(itemIndex) }
      ]},[_vm._v("\n      "+_vm._s(item.title)+"\n      "),_c('svgicon',{staticClass:"tva-accordion-item-arrow",attrs:{"icon":"actions-navigation-chevron-up","width":"20","height":"20"}})],1),_c('div',{class:[
        'tva-accordion-item-paragraph',
        'accordion-entry-content',
        'normal',
        'white',
        { closed: _vm.isSectionClosed(itemIndex) }
      ],domProps:{"innerHTML":_vm._s(item.paragraph)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }